import { InvoiceSendingState } from '@features/invoicesLegacy/types/invoiceSendingState'

export const fixableSendingStates: InvoiceSendingState[] = ['failed', 'voided', 'deleted']
